import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';

import Template from 'templates/Default';

import Page from 'pages/Meetings';

import WithMustBeLogged from 'hooks/auth/withMustBeLogged';

import commonLangs from 'config/commonLangs';
import seo from 'config/seo';

const pageLangs = ['meetings'];

const PageMeetings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <NextSeo title={`${seo.title} - ${t(`meetings:title`)}`} />

      <Template>
        <Page />
      </Template>
    </>
  );
};

export default WithMustBeLogged(PageMeetings);

export const getServerSideProps: GetServerSideProps = async (context) => ({
  props: {
    ...(await serverSideTranslations(context.locale || 'ptBR', [...commonLangs, ...pageLangs])),
  },
});
